<div class="button-container" [class.outline]="outline">
    <button class="left-button" type="button" (click)="click($event)"
        [disabled]="disabled">
        <div class="icon" *ngIf="iconSrc">
            <svg-icon [src]="iconSrc"></svg-icon>
        </div>
        <div class="icon" *ngIf="haveIcon && !iconSrc">
            <svg-icon src="assets/images/icon-add.svg"></svg-icon>
        </div>
        <span class="app-button-label">{{label}}</span>
    </button>
    <button class="right-button" type="button"
        (click)="handleShowOptions($event)" [class.active]="showOptions"
        [disabled]="disabled">
        <div>
            <svg-icon src="assets/images/icon-down.svg"></svg-icon>
        </div>
    </button>
    <div class="dropdown" *ngIf="showOptions">
        <ng-content></ng-content>
    </div>
</div>